import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';


export const LoginEvents: AnalyticsBrandSettings = {

  accesoLoginPerfilCompradorCompraInvitado(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers } = data;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'perfil_comprador', 'acceso_login', 'compra_invitado');
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['7'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }

    return settingsGTM;
  },

  accesoLoginPerfilCompradorErrorFormulario(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const field = componentData.field;
    const form = componentData.form || 'login';

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', `error_${form}`, field
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilUsuarioErrorFormulario(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const field = componentData.field;
    const form = componentData.form || 'login';

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', `error_${form}`, field
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilCompradorErrorServidor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const cod = componentData.errorCode;
    const desc = componentData.errorDescription;
    const form = componentData.form || 'login';

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', `error_servidor_${form}`, `cod_${cod}-desc_${desc}`
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilUsuarioErrorServidor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const cod = componentData.errorCode;
    const desc = componentData.errorDescription;
    const form = componentData.form || 'login';

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', `error_servidor_${form}`, `cod_${cod}-desc_${desc}`
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilCompradorIniciarSesionOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', 'iniciar_sesion_ok', 'email'
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['10', '136', '38', '55', '59', '68', '88', '89', '7'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }

    return settingsGTM;
  },

  accesoLoginPerfilUsuarioIniciarSesionOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', 'iniciar_sesion_ok', 'email'
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['10', '136', '38', '55', '59', '68', '88', '89', '7'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }

    return settingsGTM;
  },

  accesoLoginPerfilUsuarioLoginFacebook(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', 'login_facebook'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilCompradorLoginFacebook(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', 'login_facebook'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilCompradorRecuperarContrasena(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', 'recuperar_contrasena'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilCompradorRecuperarContrasenaOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', 'recuperar_contrasena_ok'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilUsuarioRecuperarContrasena(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', 'recuperar_contrasena'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilUsuarioRecuperarContrasenaOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', 'recuperar_contrasena_ok'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilCompradorRegistrarse(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', 'registrarse'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilUsuarioRegistrarse(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', 'registrarse'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilCompradorSesionPermanente(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'acceso_login', 'sesion_permanente'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  accesoLoginPerfilUsuarioSesionPermanente(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'acceso_login', 'sesion_permanente'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

};
